var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('Header',{attrs:{"title":"公告"}}),_c('div',{staticClass:"notice-html notice-html-specInfo",domProps:{"innerHTML":_vm._s(_vm.noticeContent)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }